<template>
  <div class="form-wrapper">
    <slot />
  </div>
</template>

<style scoped>
.form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
